import { useEffect } from 'react';

function Redirect({ to }) {
    useEffect(() => {
        window.location.href = to;
    }, [to]);

    return null;
}

export default Redirect;
